<template>
  <div class="animated fadeIn">
    <b-row>
      <!-- <h1>Sistemas!!</h1> -->
      <b-col xs="12" lg="12">
        <b-card no-body>
          <b-tabs card pills vertical nav-wrapper-class="w-40" v-model="tabIndex">
            <b-button style="background-color:#f0f3f5; font-size:12px;" v-if="tabx" @click="mostrar_ocultar(false)"><i class="fa fa-arrow-left"></i></b-button>
            <b-button style="background-color:#f0f3f5; font-size:12px;" v-if="!tabx" @click="mostrar_ocultar(true)"><i class="fa fa-arrow-right"></i></b-button>
            <b-tab>
                <span slot="title" v-show="tabx">
                  <i class="icon-pie-chart"></i> {{ tabs[0] }}
                </span>
                <span slot="title" v-show="iconx">
                  <i class="icon-pie-chart"></i>
                </span>
              <Sga v-if="tabIndex === 0"></Sga>
            </b-tab>
            <b-tab>
                <span slot="title" v-show="tabx">
                  <i class="icon-pie-chart"></i> {{ tabs[1] }}
                </span>
              <span slot="title" v-show="iconx">
                  <i class="icon-pie-chart"></i>
                </span>
              <SgaCompleto v-if="tabIndex === 1"></SgaCompleto>
            </b-tab>
            <b-tab>
                <span slot="title" v-show="tabx">
                  <i class="icon-pie-chart"></i> {{ tabs[2] }}
                </span>
              <span slot="title" v-show="iconx">
                  <i class="icon-pie-chart"></i>
                </span>
              <FrasesSga v-if="tabIndex === 2"></FrasesSga>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {mapActions, mapMutations} from 'vuex'
import loader from "../../../containers/loader";

import Sga from './sga/Sga';
import SgaCompleto from './sga/SgaCompleto.vue';
import FrasesSga from './sga/FrasesSga.vue';

export default {
  name: 'SistemasClasificacion',
  data() {
    return {
      mostrar: true,
      ocultar: false,
      tabx: true,
      iconx: false,
      tabIndex: null,
      tabs: [
        'Sga',
        'Sga Completo',
        'Frases SGA'
      ],
      control: 0,
      pruebas: true
    }
  },
  components: {
    Sga,
    SgaCompleto,
    FrasesSga,
    loader
  },
  watch: {
    async tabIndex(newValue) {
      this.load(true);
      switch (newValue) {
        case 0:
          await this.traeSga();
          break;
        case 1:
          await this.traeSgaCompleto();
          break;
        case 2:
          await this.traeFrases();
          break;
      }
      this.load(false);
    }
  },
  methods: {
    async traeSga() {
      await this.getJsonSga();
      if (this.$route.params.id != "crear") {
        await this.getSga();
        await this.getCategorias();
      }
    },
    async traeSgaCompleto() {

      if (this.$route.params.id != "crear") {
        await this.getSgaCompleto();
        await this.getPictogramas();
      }

    },
    async traeFrases() {
      await this.getFrases();
      await this.getEppIcos();
      await this.getPictogramas();
    },
    ...mapActions('sga_et', [
      'getJsonSga',
      'getSga',
      'getPictogramas',
      'getFrases',
      'getCategorias'
    ]),
    ...mapActions('sgacompleto_et', [
      'getSgaCompleto'
    ]),
    ...mapActions('epps_et', [
      'getEppIcos'
    ]),
    ...mapMutations('dashboard', [
      'load'
    ]),
    mostrar_ocultar(estado) {
      let self = this;
      if (estado == false) {
        self.tabx = false;
        self.iconx = true;
      } else {
        self.tabx = true;
        self.iconx = false;
      }
    }
  }
}
</script>
<style>
.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
  color: #fff;
  background-color: #097b83;
}
</style>
